<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Identificação
          </span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <span>
            - Sr(a). Licitante: o preenchimento das informações abaixo não possui efeito legal para participar das licitações,
            servindo apenas como cadastro para a realização de 'Download do Edital', porém sugerimos que identifique-se.
            Desta forma, você estará recebendo email notificando as alterações realizadas no edital e seus anexos.
          </span>
        </v-card-text>

        <v-card-text>
          <v-flex xs12 sm4 d-flex>
            <div class="az-text">
              <label class="label">Identificar-se</label>
              <div>
                <v-radio-group v-model="identificarSe" row class="radio-group-esc-imp">
                  <v-radio label="Sim" value="S"></v-radio>
                  <v-radio label="Não" value="N"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-flex>
        </v-card-text>

        <v-card-text v-if="ehIdentificavel">
          <v-flex xs12 sm4 d-flex>
            <div class="az-text">
              <label class="label">Pessoa</label>
              <div>
                <v-radio-group v-model="tipoPessoa" row class="radio-group-esc-imp">
                  <v-radio label="Jurídica" value="J"></v-radio>
                  <v-radio label="Física" value="F"></v-radio>
                </v-radio-group>
              </div>
            </div>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text pr-3">
                <div v-if="ehPessoaFisica">
                  <label class="label">Nome</label>
                  <v-text-field
                      name="Nome" class="required-field pt-0"
                      placeholder="Informe o nome"
                      v-model="fornecedor.nomeRazaoSocial"
                  ></v-text-field>
                </div>
                <div v-else>
                  <label class="label">Razão Social</label>
                  <v-text-field
                      name="Razão Social" class="required-field pt-0"
                      placeholder="Informe a razão social"
                      v-model="fornecedor.nomeRazaoSocial"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text">
                <div v-if="ehPessoaFisica">
                  <label class="label">CPF</label>
                  <v-text-field name="CPF" class="required-field pt-0"
                                v-mask="customMaskCPF" placeholder="Informe o CPF"
                                v-model="fornecedor.cpfCnpj"
                  ></v-text-field>
                </div>
                <div v-else>
                  <label class="label">CNPJ</label>
                  <v-text-field name="CNPJ" class="required-field pt-0"
                                v-mask="customMaskCNPJ" placeholder="Informe o CNPJ"
                                v-model="fornecedor.cpfCnpj"
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 d-flex>
              <div class="az-text pr-3">
                <label class="label">E-mail</label>
                <v-text-field name="E-mail" class="required-field pt-0"
                              placeholder="Informe o e-mail"
                              v-model="fornecedor.email"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md6 d-flex>
              <div class="az-text">
                <label class="label">Telefone</label>
                <v-text-field name="Telefone" class="required-field pt-0"
                              placeholder="Informe o telefone"
                              v-mask="customMaskTelefone"
                              v-model="fornecedor.telefone"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout class="justify-space-between">
            <v-btn class="ml-2 mb-2" @click="fecharModal">CANCELAR</v-btn>
            <v-btn class="mr-2 mb-2 primary" @click="continuarAcao()">
              BAIXAR
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
    name: 'ModalFornecedorIdentificacao',
    props: {
        exibir: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: String,
            default: '800'
        }
    },
    computed: {
        ehPessoaFisica() {
            return this.tipoPessoa === 'F'
        },
        ehIdentificavel() {
            return this.identificarSe === 'S'
        },
    },
    data() {
        return {
            customMaskTelefone: {
                mask: '(##) #####-####',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCNPJ: {
                mask: '##.###.###/####-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            customMaskCPF: {
                mask: '###.###.###-##',
                tokens: {
                    '#': {
                        pattern: /\d/,
                        transform: v => v.toLocaleUpperCase()
                    }
                }
            },
            fornecedor: {
                nomeRazaoSocial: null,
                cpfCnpj: null,
                email: null,
                telefone: null,
            },
            tipoPessoa: 'J',
            identificarSe: 'N'
        }
    },
    methods: {
        continuarAcao() {
            const camposValidos = this.validarCampos()
            if (!camposValidos) {
                this.mostrarNotificacaoErro('Para se indentificar, preencha todos os campos corretamente')
            } else {
                this.$emit('continuarAcao', this.fornecedor)
            }
        },
        fecharModal() {
            this.limparFornecedor()
            this.$emit('fecharModal')
        },

        limparFornecedor() {
            this.fornecedor = {
                nomeRazaoSocial: null,
                cpfCnpj: null,
                email: null,
                telefone: null,
            }
        },

        validarCampos() {
            const camposObrigatorios = this.isCamposObrigatorios()

            if (camposObrigatorios) {
                return !(this.fornecedor.nomeRazaoSocial == null
                      || this.fornecedor.cpfCnpj == null
                      || this.fornecedor.email == null
                      || this.fornecedor.telefone == null)
            }
            return true
        },

        isCamposObrigatorios() {
            return (this.fornecedor.nomeRazaoSocial !== null
                  || this.fornecedor.cpfCnpj !== null
                  || this.fornecedor.email !== null
                  || this.fornecedor.telefone !== null)
        }

    }
}
</script>

<style scoped lang="stylus">
.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

</style>